export default {
  stepCreateAccount: {
    stepTitle: 'Créez votre compte',
    countryRequiredError: 'Veuillez sélectionner un pays.',
    firstNameRequiredError: 'Veuillez indiquer votre prénom.',
    lastNameRequiredError: 'Veuillez indiquer votre nom de famille.',
    passwordRequiredError: 'Veuillez saisir un mot de passe.',
    phoneNumberRequiredError: 'Veuillez saisir un numéro de téléphone valide.',
    preferredLanguageRequiredError: 'Veuillez sélectionner une langue préférée.',
    usernameRequiredError: 'Veuillez indiquer une adresse e-mail.',
    emailAlreadyRegisteredError: ({ link }) => (
      <>Désolé, cette adresse e-mail est déjà enregistrée. {link}</>
    ),
    loginInsteadLinkText: 'Se connecter à la place ?',
    validEmailError: 'Veuillez saisir une adresse e-mail valide.',
    invalidEmailError: 'Cette adresse e-mail ne semble pas valide. Veuillez la vérifier et réessayer.',
    emailMistakeError: 'Veuillez vérifier votre adresse e-mail et réessayer.',
    genericError: 'Désolé, une erreur inconnue s\'est produite. Veuillez réessayer dans quelques instants ou contacter le support client pour une assistance immédiate.',
    firstNameLabel: 'Prénom*',
    lastNameLabel: 'Nom de famille*',
    emailLabel: 'Adresse e-mail',
    phoneNumberLabel: 'Numéro de téléphone',
    passwordLabel: 'Créer un mot de passe*',
    createAccountButton: 'Créer un compte',
    guestLinkText: 'Continuer en tant qu\'invité',
    smsOptInDefaultCopy: ({ termsLink, privacyLink }) => (
      <>J'accepte de recevoir des offres et des actualités de GolfNow et GolfPass par SMS concernant des produits, des offres et des services. Des frais de messagerie et de données peuvent s'appliquer. La fréquence des messages peut varier. Les conditions générales sont consultables dans les {termsLink} SMS et la {privacyLink}</>
    ),
    smsTermsLinkText: 'Conditions d\'utilisation',
    smsPrivacyLinkText: 'Politique de confidentialité',
    countryLabel: 'Pays*',
    preferredLanguageLabel: 'Langue préférée*',
    agreeToTerms: ({ termsLink, privacyLink }) => (
      <>En créant un compte ou en utilisant nos sites ou services, j'accepte les {termsLink} et reconnais avoir lu la {privacyLink}.</>
    ),
    termsLinkText: 'Conditions d\'utilisation',
    privacyLinkText: 'Politique de confidentialité',
    signInQuestion: ({ link }) => (
      <>Vous avez déjà un compte ? {link}</>
    ),
    signInLinkText: 'Connexion'
  },
  authInitiationRequestView: {
    unableToUpdateSettingsError: 'Désolé, nous n\'avons pas pu mettre à jour vos paramètres pour le moment.',
    contactSupport: 'Veuillez contacter le support pour plus de détails.',
    clickHereInfo: ({ link }) => (
      <>{link} pour accéder aux informations de votre compte Golf Account.</>
    ),
    clickHereLinkText: 'Cliquez ici',
    applicationNotFoundError: ({ clientId }) => `Nous sommes désolés. Cette application n'existe pas ou a été désactivée. Veuillez contacter le support pour obtenir de l'aide, et mentionner ce client_id : "${clientId}"`,
    genericFetchError: 'Code de statut invalide lors de la récupération des données de l\'application. Veuillez réessayer plus tard.',
    misconfiguredApplicationError: 'Désolé, l\'application qui vous a envoyé ici est mal configurée, ou ne peut pas être trouvée dans notre système.',
    authorizeMultipleTitle: 'Autoriser ces applications ?',
    authorizeSingleTitle: ({ name }) => (
      <>Autoriser <strong>{name}</strong> ?</>
    ),
    multipleAppsIntro: ({ orgName }) => (
      <>Les applications suivantes de <strong>{orgName}</strong> souhaitent accéder aux informations de votre compte.</>
    ),
    managePreferencesInfo: ({ link }) => (
      <>Vous pouvez toujours gérer l'accès à vos données sur votre page {link}.</>
    ),
    preferencesLinkText: 'Préférences',
    agreeToTerms: ({ termsLink, privacyLink }) => (
      <>J'accepte les {termsLink} et la {privacyLink}</>
    ),
    termsLinkText: 'Conditions d\'utilisation',
    privacyLinkText: 'Politique de confidentialité',
    singleAppIntro: ({ appName, orgName }) => (
      <>L'application <strong>{appName}</strong> de <strong>{orgName}</strong> souhaite accéder aux informations de votre compte.</>
    ),
    singleAppAuthorizeInfo: 'En autorisant cette application, vous acceptez ses conditions, modalités et sa politique de confidentialité.',
    declineButton: 'Refuser',
    approveButton: 'Approuver'
  },
  stepSignIn: {
    stepTitle: 'Saisissez votre adresse e-mail pour continuer',
    emailLabel: 'Adresse e-mail',
    passwordLabel: 'Mot de passe*',
    requiredEmailError: 'Veuillez saisir une adresse e-mail.',
    requiredPasswordError: 'Veuillez saisir un mot de passe.',
    serverError: (
      <div>
        <div>Nous sommes désolés. Nos serveurs ont des difficultés à vous connecter actuellement.</div>
        <div>Veuillez réessayer plus tard.</div>
      </div>
    ),
    validEmailError: 'Veuillez saisir une adresse e-mail valide.',
    invalidEmailError: 'Cette adresse e-mail ne semble pas valide. Veuillez la vérifier et réessayer.',
    emailMistakeError: 'Veuillez vérifier votre adresse e-mail et réessayer.',
    userNotFoundError: (
      <div>
        <div>Nous n'avons trouvé aucun utilisateur avec cette adresse, ou le mot de passe ne correspond pas.</div>
        <div>Veuillez vérifier vos identifiants et réessayer.</div>
      </div>
    ),
    accountLockedError: (
      <div>
        <div>Ce compte a été temporairement verrouillé en raison d'un trop grand nombre de tentatives de connexion échouées.</div>
        <div>Veuillez réessayer plus tard, ou contacter le support client pour une assistance immédiate.</div>
      </div>
    ),
    loginButton: 'Connexion',
    forgotPasswordLinkText: 'Mot de passe oublié ?',
    createAccountQuestion: ({ link }) => (
      <>Vous n'avez pas de compte ? {link}</>
    ),
    createAccountLinkText: 'Créer un compte'
  },
  stepValidateEmail: {
    stepTitle: 'Validez votre adresse e-mail',
    emailLabel: 'Adresse e-mail',
    accountExistsError: 'Un compte existe déjà avec cette adresse e-mail.',
    rateLimitedError: 'Un e-mail de vérification a été envoyé récemment. Veuillez patienter avant de le renvoyer.',
    verificationSentToast: 'Un e-mail de vérification a été envoyé.',
    initialInstructions: ({ verifyEmail }) => (
      <>Nous sommes désolés, nous n'avons pas pu valider votre e-mail automatiquement. Saisissez l'adresse e-mail pour laquelle vous essayez de créer un compte et cliquez sur le bouton {verifyEmail} ci-dessous.</>
    ),
    verifyEmailButtonLabel: 'Vérifier l\'e-mail',
    sendExplanation: 'Nous envoyons un e-mail à cette adresse avec un lien pour vérifier l\'adresse et permettre son utilisation pour la création d\'un compte.',
    verifyEmailButton: 'Vérifier l\'e-mail',
    backToCreateAccount: 'Retour à la création de compte',
    sentConfirmation: ({ username }) => (
      <>Un e-mail a été envoyé à {username} avec un lien pour valider votre e-mail.</>
    ),
    sentExpiryInfo: 'Ce lien expirera dans 24 heures, les e-mails peuvent prendre jusqu\'à 10 minutes pour arriver, et pensez à vérifier votre dossier Spam.',
    resendButton: 'Renvoyer l\'e-mail',
    validatedConfirmation: ({ username }) => (
      <>{username} a été vérifié avec succès.</>
    ),
    validatedInstructions: 'Cliquez sur le bouton retour ci-dessous pour revenir à la page de création de compte.',
    backButton: 'Retour'
  },
  stepTwoFactor: {
    stepTitle: 'Saisissez votre code d\'authentification à deux facteurs',
    twoFactorCodeLabel: 'Code à deux facteurs',
    requiredCodeError: 'Erreur : Veuillez saisir votre code à 6 chiffres.',
    codeLengthError: 'Erreur : Votre code doit comporter six chiffres.',
    userNotFoundError: (
      <div>
        <div>Nous n'avons trouvé aucun utilisateur avec cette adresse, ou le mot de passe ne correspond pas.</div>
        <div>Veuillez vérifier vos identifiants et réessayer.</div>
      </div>
    ),
    accountLockedError: (
      <div>
        <div>Ce compte a été temporairement verrouillé en raison d'un trop grand nombre de tentatives de connexion échouées.</div>
        <div>Veuillez réessayer plus tard, ou contacter le support client pour une assistance immédiate.</div>
      </div>
    ),
    codeExpiredError: (
      <div>
        <p>Votre code 2FA est incorrect ou a expiré.</p>
      </div>
    ),
    continueButton: 'Continuer'
  },
  stepEmailEntry: {
    stepTitle: 'Saisissez votre adresse e-mail pour continuer',
    emailLabel: 'Adresse e-mail',
    requiredEmailError: 'Veuillez saisir une adresse e-mail.',
    validEmailError: 'Veuillez saisir une adresse e-mail valide.',
    continueButton: 'Continuer'
  },
  stepForgotPassword: {
    stepTitle: 'Saisissez votre adresse e-mail pour continuer',
    emailLabel: 'Adresse e-mail',
    enterEmailInfo: 'Entrez votre adresse e-mail et nous vous envoyons un e-mail avec un lien pour réinitialiser votre mot de passe. Votre lien de réinitialisation expirera dans 24 heures.',
    sentInfo: ({ username, reSent }) => (
      <>S'il existe un compte associé à <strong>{username}</strong>, un e-mail de réinitialisation du mot de passe sera {reSent ? 'de nouveau ' : ''}envoyé.</>
    ),
    sentExpiryInfo: 'Rappel : votre lien de réinitialisation expirera dans 24 heures, les e-mails peuvent prendre jusqu\'à 10 minutes pour arriver, et pensez à vérifier votre dossier Spam.',
    sentCreateAccountQuestion: ({ link }) => (
      <>Vous n'avez pas reçu d'e-mail ? Vous n'avez pas de compte ? {link}</>
    ),
    sentCreateAccountLinkText: 'Cliquez ici pour en créer un.',
    sendButton: 'Envoyer l\'e-mail',
    resendButton: 'Renvoyer l\'e-mail',
    signInQuestion: ({ link }) => (
      <>Vous avez déjà un compte ? {link}</>
    ),
    signInLinkText: 'Connexion',
    requiredEmailError: 'Veuillez saisir une adresse e-mail.',
    validEmailError: 'Veuillez saisir une adresse e-mail valide.',
    rateLimitedError: ({ isSet }) => `Un e-mail de ${isSet ? 'définition de mot de passe' : 'réinitialisation du mot de passe'} a été envoyé récemment. Veuillez patienter avant de le renvoyer.`,
    invalidEmailError: 'Cette adresse e-mail ne semble pas valide. Veuillez la vérifier et réessayer.',
    emailMistakeError: 'Veuillez vérifier votre adresse e-mail et réessayer.',
    serverError: 'Nous sommes désolés, nos serveurs rencontrent des problèmes actuellement. Veuillez réessayer plus tard.',
    resetEmailSentConfirmation: 'E-mail de réinitialisation envoyé.'
  }
};
